import { STORAGE_KEY } from '@/constants/storage';
import store from '@/store';
import { cookieParse, prepareRouteToLogin } from '@/utils/utils';
import jwtDecode from 'jwt-decode';
import VueCookies from 'vue-cookies';

export const auth = async ({ to }) => {
    const token =
        store.state.auth.accessToken ||
        cookieParse(VueCookies.get(STORAGE_KEY.ACCESS_TOKEN));
    let valid = false;
    let redirect = prepareRouteToLogin(to);

    if (token) {
        // Logged in
        try {
            // Decode token
            const decoded = jwtDecode(token);
            const isExpired = Date.now() >= decoded.exp * 1000;

            // Check token expired
            if (!isExpired) {
                // Not expire => Valid token
                valid = true;
                redirect = undefined;
            }
        } catch (e) {
            console.error(e);
        }
    } else {
        // Not login
        await store.dispatch('auth/logout', {
            redirect: false,
        });
    }
    return {
        valid,
        redirect,
    };
};

export const loggedIn = () => {
    const token =
        store.state.auth.accessToken ||
        cookieParse(VueCookies.get(STORAGE_KEY.ACCESS_TOKEN));
    let valid = true;
    let redirect;
    if (token) {
        // Logged in
        try {
            // Decode token
            const decoded = jwtDecode(token);
            const isExpired = Date.now() >= decoded.exp * 1000;

            // Check token expired
            if (!isExpired) {
                // logged in => redirect to dashboard
                valid = false;
                redirect = {
                    name: 'dashboard',
                };
            }
        } catch (e) {
            // Not login
            store.dispatch('auth/logout', {
                redirect: false,
            });
            console.error(e);
        }
    }
    return {
        valid,
        redirect,
    };
};
